import SideMenu from '@/containers/side-menu/SideMenu.vue';
import ManagerGuardRequest from '@/pages/guard/manager-guard-request/ManagerGuardRequest';

export default [
  {
    path: '/manager-guard-request/:requestId',
    name: 'ManagerGuardRequestEdit',
    components: {
      mainContent: ManagerGuardRequest,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'guard-request-info',
      },
      breadcrumb: {
        title: 'Guarda municipal - Requisição',
        paths: [{ title: 'Info' }],
      },
    },
  },
  {
    path: '/manager-guard-request',
    name: 'ManagerGuardRequest',
    components: {
      mainContent: ManagerGuardRequest,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'guard-request-info',
      },
      breadcrumb: {
        title: 'Guarda municipal - Requisição',
        paths: [{ title: 'Novo' }],
      },
    },
  },
];
